import { createAction } from '@reduxjs/toolkit';

import { type Upload } from '@air/redux-uploader';

import { type PublicUploadMetadata } from '~/store/publicUploadMetadata/types';

export const setPublicUploadMetadata = createAction<{ uploadId: Upload['id']; metadata: PublicUploadMetadata }>(
  'SET_PUBLIC_UPLOAD_METADATA',
);
